export default "__VITE_ASSET__C1DyTLs2__"